export const P = {
  ORDERS_READ_ALL: "orders:read_all",
  ORDERS_READ_VA: "orders:read_va",
  ORDERS_READ_ASSIGNED: "orders:read_assigned",
  ORDERS_READ_OWN: "orders:read_own",
  ORDERS_READ_DETAIL: "orders:read_detail",
  ORDERS_UPDATE_STATUS: "orders:update_status",
  ORDERS_UPDATE_PROPERTIES: "orders:update_properties",
  ORDERS_CANCEL: "orders:cancel",
  ORDERS_NOTES_WRITE: "orders:notes_write",
  ORDERS_REDO: "orders:redo",
  ORDERS_EXPORT: "orders:export",
  ORDERS_UPLOAD_SHEET: "orders:upload_sheet",
  ORDERS_UPLOAD_TRACKING: "orders:upload_tracking",
  ORDERS_SEND_TRACKING_MAIL: "orders:send_tracking_mail",
  ORDERS_MARK_SEEN: "orders:mark_seen",
  VA_INVOICE_UPLOAD: "va:invoice_upload",
  VA_DEVICE_ORDER_CREATE: "va:device_order_create",
  VA_DEMO_ORDER_CREATE: "va:demo_order_create",
  VA_DISTRIBUTOR_MANAGE: "va:distributor_manage",
  SHOPIFY_SYNC: "shopify:sync",
  PRESCRIPTION_SEND_MAIL: "prescription:send_mail",
  AUDIOLOGIST_ORDER_CREATE: "audiologist:order_create",
  AUDIOLOGIST_CHECKOUT: "audiologist:checkout",
};

export function hasPermission(permissions, key) {
  return Array.isArray(permissions) && permissions.includes(key);
}

export function hasAnyPermission(permissions, ...keys) {
  return keys.some((k) => hasPermission(permissions, k));
}
